"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminConfigTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const AdminDeleteGraderPage_1 = require("@frontend/views/AdminDeleteGraderPage");
const Network_1 = require("../util/Network");
const UI_1 = require("../util/UI");
const AdminDeletePage_1 = require("./AdminDeletePage");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminProvisionPage_1 = require("./AdminProvisionPage");
const AdminView_1 = require("./AdminView");
const JobRunner_1 = require("./JobRunner");
class AdminConfigTab extends AdminPage_1.AdminPage {
    constructor(remote, isAdmin) {
        super(remote);
        this.course = null;
        this.isAdmin = isAdmin;
        this.jobs = new JobRunner_1.JobRunner(remote);
    }
    setAdmin(isAdmin) {
        Log_1.default.info("AdminConfigTab::isAdmin( " + isAdmin + " )");
        this.isAdmin = isAdmin;
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            Log_1.default.info("AdminConfigTab::init(..) - start");
            const that = this;
            yield this.initJobSections();
            document.querySelector("#adminSubmitClasslist").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - upload classlist pressed");
                evt.stopPropagation();
                const fileInput = document.querySelector("#adminClasslistFile");
                const isValid = that.validateFileSpecified(fileInput);
                if (isValid === true) {
                    that
                        .uploadClasslist(fileInput.files)
                        .then(function () {
                    })
                        .catch(function (err) {
                        Log_1.default.error("AdminConfigTab::handleAdminConfig(..) - upload classlist pressed ERROR: " + err.message);
                    });
                }
            };
            document.querySelector("#adminSubmitGradeCSV").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - upload grades pressed");
                evt.stopPropagation();
                const fileInput = document.querySelector("#adminGradeCSV");
                const isValid = that.validateFileSpecified(fileInput);
                if (isValid === true) {
                    const delivDropdown = document.querySelector("#adminGradeDeliverableSelect");
                    const delivId = delivDropdown.value;
                    if (delivId === "") {
                        UI_1.UI.showAlert("Select the deliverable the grades are for.");
                        return;
                    }
                    that
                        .uploadGrades(fileInput.files, delivId)
                        .then(function () {
                    })
                        .catch(function (err) {
                        Log_1.default.error("AdminConfigTab::handleAdminConfig(..) - upload grades pressed ERROR: " + err.message);
                    });
                }
            };
            document.querySelector("#adminSubmitGradePrairieCSV").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - upload prairie grades pressed");
                evt.stopPropagation();
                const fileInput = document.querySelector("#adminGradePrairieCSV");
                const isValid = that.validateFileSpecified(fileInput);
                if (isValid === true) {
                    that
                        .uploadGradesPrairie(fileInput.files)
                        .then(function () {
                    })
                        .catch(function (err) {
                        Log_1.default.error("AdminConfigTab::handleAdminConfig(..) - upload grades pressed ERROR: " + err.message);
                    });
                }
            };
            document.querySelector("#adminSubmitDefaultDeliverable").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - default deliverable pressed");
                evt.preventDefault();
                evt.stopPropagation();
                that
                    .defaultDeliverablePressed()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - default deliverable pressed; ERROR: " + err.message);
                });
            };
            document.querySelector("#adminManageTeamsButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - team management page pressed");
                evt.preventDefault();
                that
                    .pushPage("./adminTeamManagement.html", {})
                    .then(function () {
                    return that.initTeamManagementPage();
                })
                    .catch(function (err) {
                    Log_1.default.error("AdminConfigTab - adminTeamManagement ERROR: " + err.message);
                });
            };
            document.querySelector("#adminDeletePageButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - delete page pressed");
                evt.preventDefault();
                that
                    .pushPage("./adminDelete2.html", {})
                    .then(function () {
                    const deletePage = new AdminDeletePage_1.AdminDeletePage(that.remote);
                    deletePage
                        .init({})
                        .then(function () {
                        Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - delete page init");
                    })
                        .catch(function (err) {
                        Log_1.default.error("AdminConfigTab::handleAdminConfig(..) - delete page ERROR: " + err);
                    });
                })
                    .catch(function (err) {
                    Log_1.default.error("AdminConfigTab - adminDelete ERROR: " + err.message);
                });
            };
            document.querySelector("#adminManageDeliverablesButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - manage deliverables page pressed");
                evt.preventDefault();
                that.pushPage("./adminDeliverables.html", {}).catch(function (err) {
                    Log_1.default.error("AdminConfigTab - adminDeliverables ERROR: " + err.message);
                });
            };
            document.querySelector("#adminManageRepositoriesButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - manage repo page pressed");
                evt.preventDefault();
                that
                    .pushPage("./adminProvision.html", {})
                    .then(function () {
                    const provisionPage = new AdminProvisionPage_1.AdminProvisionPage(that.remote);
                    provisionPage
                        .init({})
                        .then(function () {
                        Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - provision page init");
                    })
                        .catch(function (err) {
                        Log_1.default.error("AdminConfigTab::handleAdminConfig(..) - provision page ERROR: " + err);
                    });
                })
                    .catch(function (err) {
                    Log_1.default.error("AdminConfigTab - adminProvision ERROR: " + err.message);
                });
            };
            document.querySelector("#adminRemoveGraderImagesPageButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - remove grader images page pressed");
                evt.preventDefault();
                that
                    .pushPage("./adminGraderImages.html", {})
                    .then(function () {
                    const deleteImagePage = new AdminDeleteGraderPage_1.AdminDeleteGraderPage(that.remote);
                    deleteImagePage
                        .init({})
                        .then(function () {
                        Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - image delete page init");
                    })
                        .catch(function (err) {
                        Log_1.default.error("AdminConfigTab::handleAdminConfig(..) - image delete page ERROR: " + err);
                    });
                })
                    .catch(function (err) {
                    Log_1.default.error("AdminConfigTab imageDelete ERROR: " + err.message);
                });
            };
            UI_1.UI.showModal("Retriving config / deliverable details.");
            this.course = yield AdminView_1.AdminView.getCourse(this.remote);
            const deliverables = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote);
            const gradesDeliverableDropdown = document.querySelector("#adminGradeDeliverableSelect");
            const defaultDeliverableDropdown = document.querySelector("#adminDefaultDeliverableSelect");
            const defaultDeliverableOptions = ["--Not Set--"];
            const gradesOptions = ["--Select--"];
            const allDeliverables = ["--Select--"];
            for (const deliv of deliverables) {
                if (deliv.shouldAutoTest === true) {
                    defaultDeliverableOptions.push(deliv.id);
                }
                if (deliv.shouldProvision === true) {
                    gradesOptions.push(deliv.id);
                }
                allDeliverables.push(deliv.id);
            }
            this.populateDelivSelect(defaultDeliverableOptions, defaultDeliverableDropdown);
            this.populateDelivSelect(allDeliverables, gradesDeliverableDropdown);
            defaultDeliverableDropdown.selectedIndex = 0;
            const stored = (_a = this.course) === null || _a === void 0 ? void 0 : _a.defaultDeliverableId;
            if (typeof stored === "string" && stored.length > 0) {
                for (const o of Array.from(defaultDeliverableDropdown.options)) {
                    if (o.value === stored) {
                        o.selected = true;
                    }
                }
            }
            UI_1.UI.hideModal();
        });
    }
    populateDelivSelect(delivOptions, dropdown) {
        delivOptions = delivOptions.sort();
        dropdown.innerHTML = "";
        for (const delivId of delivOptions) {
            let value = delivId;
            if (delivId.startsWith("--")) {
                value = "";
            }
            const o = new Option(delivId, value, false, false);
            dropdown.add(o);
        }
    }
    validateFileSpecified(fileInput) {
        if (fileInput.value.length > 0) {
            Log_1.default.trace("AdminConfigTab::validateFileSpecified() - validation passed");
            return true;
        }
        else {
            UI_1.UI.notification("You must select a CSV before you click Upload.");
            return false;
        }
    }
    uploadClasslist(fileList) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminConfigTab::uploadClasslist(..) - start");
            const url = this.remote + "/portal/admin/classlist";
            UI_1.UI.showModal("Uploading classlist.");
            try {
                const formData = new FormData();
                formData.append("classlist", fileList[0]);
                const opts = {
                    headers: {
                        user: localStorage.user,
                        token: localStorage.token,
                    },
                };
                const response = yield Network_1.Network.httpPostFile(url, opts, formData);
                if (response.status >= 200 && response.status < 300) {
                    const data = yield response.json();
                    UI_1.UI.hideModal();
                    Log_1.default.info("AdminConfigTab::uploadClasslist(..) - RESPONSE: " + JSON.stringify(data));
                    if (typeof data.success !== "undefined") {
                        UI_1.UI.notificationToast(data.success.message);
                        this.showClasslistChanges(data.success);
                    }
                }
                else {
                    const reason = yield response.json();
                    UI_1.UI.hideModal();
                    if (typeof reason.failure && typeof reason.failure.message) {
                        UI_1.UI.notification("There was an issue uploading your class list. " +
                            "Please ensure the CSV file includes all required columns. <br/>Details: " +
                            reason.failure.message);
                    }
                    else {
                        UI_1.UI.notification("There was an issue uploading your class list. " + "Please ensure the CSV file includes all required columns.");
                    }
                }
            }
            catch (err) {
                UI_1.UI.hideModal();
                Log_1.default.error("AdminConfigTab::uploadClasslist(..) - ERROR: " + err.message);
                AdminView_1.AdminView.showError(err);
            }
            Log_1.default.trace("AdminConfigTab::uploadClasslist(..) - end");
        });
    }
    uploadGrades(fileList, delivId) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminConfigTab::uploadGrades(..) - start");
            const url = this.remote + "/portal/admin/grades/csv/" + delivId;
            UI_1.UI.showModal("Uploading grades.");
            try {
                const formData = new FormData();
                formData.append("gradelist", fileList[0]);
                const opts = {
                    headers: {
                        user: localStorage.user,
                        token: localStorage.token,
                    },
                };
                const response = yield Network_1.Network.httpPostFile(url, opts, formData);
                if (response.status >= 200 && response.status < 300) {
                    const data = yield response.json();
                    UI_1.UI.hideModal();
                    Log_1.default.info("AdminConfigTab::uploadGrades(..) - RESPONSE: " + JSON.stringify(data));
                    UI_1.UI.notification(data.success.message);
                }
                else {
                    const reason = yield response.json();
                    UI_1.UI.hideModal();
                    if (typeof reason.failure && typeof reason.failure.message) {
                        UI_1.UI.notification("There was an issue uploading your grade CSV. " +
                            "Please ensure the CSV file includes all required columns. <br/>Details: " +
                            reason.failure.message);
                    }
                    else {
                        UI_1.UI.notification("There was an issue uploading your grade CSV. " + "Please ensure the CSV file includes all required columns.");
                    }
                }
            }
            catch (err) {
                UI_1.UI.hideModal();
                Log_1.default.error("AdminConfigTab::uploadGrades(..) - ERROR: " + err.message);
                AdminView_1.AdminView.showError(err);
            }
            Log_1.default.trace("AdminConfigTab::uploadGrades(..) - end");
        });
    }
    uploadGradesPrairie(fileList) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminConfigTab::uploadGradesPrairie(..) - start");
            const url = this.remote + "/portal/admin/grades/prairie";
            UI_1.UI.showModal("Uploading PrairieLearn GradeBook.");
            try {
                const formData = new FormData();
                formData.append("gradelist", fileList[0]);
                const opts = {
                    headers: {
                        user: localStorage.user,
                        token: localStorage.token,
                    },
                };
                const response = yield Network_1.Network.httpPostFile(url, opts, formData);
                if (response.status >= 200 && response.status < 300) {
                    const data = yield response.json();
                    UI_1.UI.hideModal();
                    Log_1.default.info("AdminConfigTab::uploadGradesPrairie(..) - RESPONSE: " + JSON.stringify(data));
                    UI_1.UI.notification(data.success.message);
                }
                else {
                    const reason = yield response.json();
                    UI_1.UI.hideModal();
                    if (typeof reason.failure && typeof reason.failure.message) {
                        UI_1.UI.notification("There was an issue uploading your grade CSV. " +
                            "Please ensure the CSV file includes all required columns. <br/>Details: " +
                            reason.failure.message);
                    }
                    else {
                        UI_1.UI.notification("There was an issue uploading your grade CSV. " + "Please ensure the CSV file includes all required columns.");
                    }
                }
            }
            catch (err) {
                UI_1.UI.hideModal();
                Log_1.default.error("AdminConfigTab::uploadGradesPrairie(..) - ERROR: " + err.message);
                AdminView_1.AdminView.showError(err);
            }
            Log_1.default.trace("AdminConfigTab::uploadGradesPrairie(..) - end");
        });
    }
    initTeamManagementPage() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminConfigTab::initTeamManagementPage(..) - start");
            const that = this;
            document.querySelector("#adminCreateTeamButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - create team pressed");
                evt.preventDefault();
                evt.stopPropagation();
                that
                    .teamCreatePressed()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - create team pressed; ERROR: " + err.message);
                });
            };
            document.querySelector("#adminDeleteTeamManageButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - delete team pressed");
                evt.preventDefault();
                evt.stopPropagation();
                that
                    .teamDeletePressed()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - delete team pressed; ERROR: " + err.message);
                });
            };
            document.querySelector("#adminTeamAddMemberButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - add member to team pressed");
                evt.preventDefault();
                evt.stopPropagation();
                that
                    .teamAddMemberPressed()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - add member to team pressed; ERROR: " + err.message);
                });
            };
            document.querySelector("#adminTeamRemoveMemberButton").onclick = function (evt) {
                Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - remove member to team pressed");
                evt.preventDefault();
                evt.stopPropagation();
                that
                    .teamRemoveMemberPressed()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.info("AdminConfigTab::handleAdminConfig(..) - remove member to team pressed; ERROR: " + err.message);
                });
            };
            const deliverables = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote);
            const provisionOptions = ["--Select--"];
            for (const deliv of deliverables) {
                if (deliv.shouldProvision === true) {
                    provisionOptions.push(deliv.id);
                }
            }
            this.populateDelivSelect(provisionOptions, document.querySelector("#adminTeamDeliverableSelect"));
        });
    }
    teamCreatePressed() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("AdminConfigTab::teamCreatePressed(..) - start");
            const delivDropdown = document.querySelector("#adminTeamDeliverableSelect");
            const delivId = delivDropdown.value;
            if (delivId === "") {
                UI_1.UI.showAlert("Select the deliverable the team is for.");
                return;
            }
            const names = UI_1.UI.getTextFieldValue("adminTeamText");
            let nameList = names.split(",");
            nameList = nameList.map(Function.prototype.call, String.prototype.trim);
            const url = this.remote + "/portal/admin/team";
            const options = AdminView_1.AdminView.getOptions();
            options.method = "post";
            const team = {
                delivId: delivId,
                githubIds: nameList,
            };
            Log_1.default.trace("AdminConfigTab::teamCreatePressed(..) - body: " + JSON.stringify(team));
            options.body = JSON.stringify(team);
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                UI_1.UI.showSuccessToast("Team created successfully: " + body.success[0].id);
                UI_1.UI.clearTextField("adminTeamText");
            }
            else {
                UI_1.UI.showAlert(body.failure.message);
            }
        });
    }
    teamDeletePressed() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("AdminConfigTab::teamDeletePressed(..) - start");
            const teamId = UI_1.UI.getTextFieldValue("adminDeleteTeamManageTeam");
            const url = this.remote + "/portal/admin/team/" + teamId;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "delete";
            Log_1.default.trace("AdminConfigTab::teamDeletePressed(..) - body: " + JSON.stringify({}));
            options.body = JSON.stringify({});
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                UI_1.UI.showSuccessToast("Team deleted successfully: " + body.success.message);
                UI_1.UI.clearTextField("adminDeleteTeamManageTeam");
            }
            else {
                UI_1.UI.showAlert(body.failure.message);
            }
        });
    }
    teamAddMemberPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("AdminConfigTab::teamAddMemberPressed(..) - start");
            const teamId = UI_1.UI.getTextFieldValue("adminTeamAddMemberTeam");
            const memberId = UI_1.UI.getTextFieldValue("adminTeamAddMemberMember");
            const url = this.remote + "/portal/admin/team/" + teamId + "/members/" + memberId;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "post";
            Log_1.default.trace("AdminConfigTab::teamAddMemberPressed(..) - body: " + JSON.stringify({}));
            options.body = JSON.stringify({});
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                UI_1.UI.showSuccessToast("Team member added successfully: " + body.success.message);
                UI_1.UI.clearTextField("adminTeamAddMemberTeam");
                UI_1.UI.clearTextField("adminTeamAddMemberMember");
            }
            else {
                UI_1.UI.showAlert(body.failure.message);
            }
        });
    }
    teamRemoveMemberPressed() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("AdminConfigTab::teamRemoveMemberPressed(..) - start");
            const teamId = UI_1.UI.getTextFieldValue("adminTeamRemoveMemberTeam");
            const memberId = UI_1.UI.getTextFieldValue("adminTeamRemoveMemberMember");
            const url = this.remote + "/portal/admin/team/" + teamId + "/members/" + memberId;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "delete";
            Log_1.default.trace("AdminConfigTab::teamRemoveMemberPressed(..) - body: " + JSON.stringify({}));
            options.body = JSON.stringify({});
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                UI_1.UI.showSuccessToast("Team member removed successfully: " + body.success.message);
                UI_1.UI.clearTextField("adminTeamRemoveMemberTeam");
                UI_1.UI.clearTextField("adminTeamRemoveMemberMember");
            }
            else {
                UI_1.UI.showAlert(body.failure.message);
            }
        });
    }
    showClasslistChanges(classlistChanges) {
        Log_1.default.info("AdminConfigTab::showClasslistChanges(..) - changes: " + JSON.stringify(classlistChanges));
        const mapToTextAndSubtext = function (people) {
            return people.map(function (person) {
                return {
                    text: person.id + "/" + person.studentNum + "/" + person.githubId + ": " + person.firstName + " " + person.lastName,
                    subtext: person.labId,
                };
            });
        };
        if (classlistChanges.created.length) {
            const createdList = mapToTextAndSubtext(classlistChanges.created);
            UI_1.UI.templateConfirm("classlistDialog.html", {
                header: "Created: May need Repos Provisioned",
                listContent: createdList,
            });
        }
        if (classlistChanges.updated.length) {
            const updatedList = mapToTextAndSubtext(classlistChanges.updated);
            UI_1.UI.templateConfirm("classlistDialog.html", {
                header: "Updated: Student data has been modified in new Classlist upload",
                listContent: updatedList,
            });
        }
        if (classlistChanges.removed.length) {
            const removedList = mapToTextAndSubtext(classlistChanges.removed);
            UI_1.UI.templateConfirm("classlistDialog.html", {
                header: "Removed: NOT in latest Classlist upload. To Be Withdrawn",
                listContent: removedList,
            });
        }
    }
    static classlistSummaryMessage(summary) {
        return ("# registered: " +
            summary.classlist.length +
            "; # added: " +
            summary.created.length +
            "; # updated: " +
            summary.updated.length +
            "; # removed: " +
            summary.removed.length +
            "; # not active (on classlist): " +
            summary.notActive.length +
            AdminConfigTab.kindBreakdown(summary.notActiveByKind));
    }
    static kindBreakdown(byKind) {
        const parts = Object.keys(byKind !== null && byKind !== void 0 ? byKind : {})
            .sort()
            .map((kind) => kind + ": " + byKind[kind]);
        return parts.length > 0 ? " (" + parts.join(", ") + ")" : "";
    }
    initJobSections() {
        return __awaiter(this, void 0, void 0, function* () {
            const sections = [
                {
                    kind: "classlist-update",
                    buttonId: "adminUpdateClasslist",
                    statusId: "adminUpdateClasslistStatus",
                    ran: "Last updated",
                    detail: function (summary) {
                        return AdminConfigTab.classlistSummaryMessage(summary);
                    },
                    onFinished: (summary) => {
                        UI_1.UI.notificationToast("Classlist updated: " + AdminConfigTab.classlistSummaryMessage(summary));
                        this.showClasslistChanges(summary);
                    },
                },
                {
                    kind: "user-sync",
                    buttonId: "adminSynchronizeUsersButton",
                    statusId: "adminSynchronizeUsersStatus",
                    ran: "Last run",
                    detail: function (summary) {
                        return summary.message;
                    },
                    onFinished: (summary) => {
                        UI_1.UI.notificationToast("User synchronization complete: " + summary.message, 5000);
                    },
                },
            ];
            if ((yield this.isPrairieLearnEnabled()) === true) {
                document.querySelector("#adminPrairieLearnSyncItem").style.display = "";
                const reinterpretItem = document.querySelector("#adminPrairieLearnReinterpretItem");
                if (reinterpretItem !== null) {
                    reinterpretItem.style.display = "";
                    sections.push({
                        kind: "prairielearn-reinterpret",
                        buttonId: "adminPrairieLearnReinterpretButton",
                        cancelButtonId: "adminPrairieLearnReinterpretCancelButton",
                        statusId: "adminPrairieLearnReinterpretStatus",
                        ran: "Last re-derived",
                        neverRun: "Never re-derived.",
                        detail: AdminConfigTab.describePrairieLearnReinterpret,
                    });
                }
                sections.push({
                    kind: "prairielearn-sync",
                    buttonId: "adminPrairieLearnSyncButton",
                    cancelButtonId: "adminPrairieLearnCancelButton",
                    statusId: "adminPrairieLearnStatus",
                    ran: "Last synced",
                    neverRun: "Never synced.",
                    detail: AdminConfigTab.describePrairieLearnSummary,
                    params: () => {
                        const force = document.querySelector("#adminPrairieLearnForce");
                        return { force: force !== null && force.checked === true };
                    },
                });
            }
            yield Promise.all(sections.map((section) => this.jobs.init(section)));
        });
    }
    isPrairieLearnEnabled() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (document.querySelector("#adminPrairieLearnSyncItem") === null) {
                return false;
            }
            try {
                const response = yield fetch(this.remote + "/portal/config", AdminView_1.AdminView.getOptions());
                const json = yield response.json();
                return ((_a = json === null || json === void 0 ? void 0 : json.success) === null || _a === void 0 ? void 0 : _a.prairieLearnEnabled) === true;
            }
            catch (err) {
                Log_1.default.warn("AdminConfigTab::isPrairieLearnEnabled() - could not read config; ERROR: " + err.message);
                return false;
            }
        });
    }
    static describePrairieLearnReinterpret(summary) {
        if (typeof summary === "undefined" || summary === null) {
            return "";
        }
        const parts = [summary.resultsRewritten + " of " + summary.resultsSeen + " results re-derived"];
        if (summary.resultsWithoutArchive > 0) {
            parts.push(summary.resultsWithoutArchive + " have no stored payload (force a sync for those)");
        }
        if (Array.isArray(summary.resultsFailed) && summary.resultsFailed.length > 0) {
            parts.push(summary.resultsFailed.length + " could not be read");
        }
        if (summary.cancelled === true) {
            parts.push("cancelled");
        }
        return parts.join("; ");
    }
    static describePrairieLearnSummary(summary) {
        var _a, _b, _c, _d, _e, _f;
        let detail = summary.gradesWritten + " grades, " + summary.resultsWritten + " results, " + summary.instancesSkipped + " unchanged";
        if (((_a = summary.deliverablesCreated) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            detail += "; created " + summary.deliverablesCreated.join(", ");
        }
        if (summary.submissionsAfterClose > 0) {
            detail += "; " + summary.submissionsAfterClose + " attempt(s) after close (not graded)";
        }
        if (((_b = summary.unmatchedUids) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            detail += "; <b>" + summary.unmatchedUids.length + " unmatched student(s)</b>";
        }
        if (((_c = summary.unmatchedNonStudentUids) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            detail += "; " + summary.unmatchedNonStudentUids.length + " unmatched non-student(s)";
        }
        if (((_d = summary.skippedWithoutGrade) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            detail += "; " + summary.skippedWithoutGrade.length + " unchanged, still without a grade";
        }
        if (((_e = summary.noGradeableSubmission) === null || _e === void 0 ? void 0 : _e.length) > 0) {
            detail += "; " + summary.noGradeableSubmission.length + " with no gradeable submission";
        }
        if (((_f = summary.allAfterClose) === null || _f === void 0 ? void 0 : _f.length) > 0) {
            detail += "; " + summary.allAfterClose.length + " graded only after close";
        }
        if (summary.noSubmissions > 0) {
            detail += "; " + summary.noSubmissions + " never submitted";
        }
        if (summary.submissionsNotGradeable) {
            const n = summary.submissionsNotGradeable;
            detail +=
                "; un-gradeable submissions: " +
                    n.graderFailed +
                    " grader failed, " +
                    n.noFeedback +
                    " no feedback, " +
                    n.noUsableScore +
                    " no usable score";
        }
        return detail + ".";
    }
    defaultDeliverablePressed() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.trace("AdminConfigTab::defaultDeliverablePressed(..) - start");
            const delivDropdown = document.querySelector("#adminDefaultDeliverableSelect");
            const value = delivDropdown.value === "" ? null : delivDropdown.value;
            this.course.defaultDeliverableId = value;
            Log_1.default.trace("AdminConfigTab::defaultDeliverablePressed(..) - value: " + value);
            const url = this.remote + "/portal/admin/course";
            const options = AdminView_1.AdminView.getOptions();
            options.method = "post";
            options.body = JSON.stringify(this.course);
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                UI_1.UI.showSuccessToast("Default deliverable saved successfully.");
            }
            else {
                UI_1.UI.showAlert(body.failure.message);
            }
        });
    }
}
exports.AdminConfigTab = AdminConfigTab;
